import httpClient from '../../httpClient'

export interface ISubscription {
  id: string
  status: string
  current_period_start: string
  current_period_end: string
  cancel_at_period_end: boolean
}

export interface ISubscriptionResponse {
  user?: {
    email: string
    name: string
  }
  subscription: ISubscription | null
  interview_count: number
  remaining_interviews: number
}

export interface ICreateSubscriptionRequest {
  stripe_price_id?: string
}

export interface ICreateSubscriptionResponse {
  client_secret: string
}

export interface ICreateCheckoutSessionRequest {
  stripe_price_id?: string
  success_url?: string
  cancel_url?: string
}

export interface ICreateCheckoutSessionResponse {
  checkout_url: string
}

export interface ICreatePortalSessionResponse {
  portal_url: string
}

const subscriptionsController = {
  createSubscription: async (
    stripe_price_id?: string
  ): Promise<ICreateSubscriptionResponse> => {
    const response = await httpClient.post<ICreateSubscriptionResponse>(
      '/subscriptions',
      {
        stripe_price_id,
      }
    )
    return response.data
  },

  createCheckoutSession: async (
    stripe_price_id?: string,
    success_url?: string,
    cancel_url?: string,
    email?: string,
    first_name?: string,
    last_name?: string,
    interview_token?: string
  ): Promise<ICreateCheckoutSessionResponse> => {
    const response = await httpClient.post<ICreateCheckoutSessionResponse>(
      '/subscriptions/checkout_session',
      {
        stripe_price_id,
        success_url,
        cancel_url,
        email,
        first_name,
        last_name,
        interview_token,
      },
      {
        skipAuthRedirect: true, // This is a public endpoint
      } as any
    )
    return response.data
  },

  checkStatus: async (
    email: string
  ): Promise<{
    has_subscription: boolean
    can_create_interview: boolean
    interview_count: number
    remaining: number
  }> => {
    const response = await httpClient.get('/subscriptions/check_status', {
      params: { email },
    })
    return response.data
  },

  getSubscription: async (): Promise<ISubscriptionResponse> => {
    const response = await httpClient.get<ISubscriptionResponse>('/subscriptions')
    return response.data
  },

  createPortalSession: async (
    return_url?: string
  ): Promise<ICreatePortalSessionResponse> => {
    const response = await httpClient.post<ICreatePortalSessionResponse>(
      '/subscriptions/portal_session',
      {
        return_url: return_url,
      }
    )
    return response.data
  },
}

export default subscriptionsController
